import { Navigate, createFileRoute } from "@tanstack/react-router";
import {
  ClientDetailWorkspace,
  isClientDetailTab,
  type ClientDetailTab,
} from "../components/admin/clients-workspace";
import { useAuth } from "../stores/auth";

export const Route = createFileRoute("/admin/clients/$clientId")({
  validateSearch: (search: Record<string, unknown>): { tab?: ClientDetailTab } => (
    isClientDetailTab(search.tab) ? { tab: search.tab } : {}
  ),
  component: AdminClientDetailPage,
});

function AdminClientDetailPage() {
  const { clientId } = Route.useParams();
  const { tab = "overview" } = Route.useSearch();
  const navigate = Route.useNavigate();
  const user = useAuth((state) => state.user);
  if (!user) return null;
  if (user.role !== "global_admin") return <Navigate to="/admin/users" replace />;
  return (
    <ClientDetailWorkspace
      clientId={clientId}
      tab={tab}
      onTabChange={(nextTab) => void navigate({ search: { tab: nextTab }, replace: true })}
    />
  );
}
